<template>
    <div class="fd-main">
        <headers></headers>
        <router-view class="fd-main-view"></router-view>
        <footers></footers>
    </div>
</template>
<script>
import headers from "@/components/common/headers";
import footers from "@/components/common/footers";
export default {
    components: { headers, footers },
};
</script>
<style lang="less">
.fd-main {
    .fd-main-view {
        min-height: calc(100vh - 280px);
    }
}
</style>


// WEBPACK FOOTER //
// src/views/main.vue